<template>
    <div class="mt-1" >
        <h4 class="headline text-xs-center">Promotion Items</h4>
        <v-layout row>           
            <v-flex xs12 class="text-xs-right">
                <v-spacer></v-spacer>
                <v-btn large @click.prevent="onCreateNewPromotion()" class="primary">Add Promotion</v-btn>
            </v-flex>
            <!-- <v-flex sm12 md6>
                <v-select
                label="Job Status"
                v-bind:items="statusList"
                v-model="searchCriteria.statusSelected"
                multiple
                hint=""
                persistent-hint
                ></v-select>
            </v-flex> -->
        </v-layout>
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>  
        <v-card>
            <v-card-text>
                <h4>Filters</h4>
                <v-layout row  py-1>
                    <v-flex >
                        <v-text-field 
                            v-model="filterNumber" 
                            label="Item #"
                            hint=""
                            ></v-text-field>
                    </v-flex>
                    <!-- <v-flex pl-1>
                        <v-select
                        v-model="filterRole"
                        :items="roles"
                        item-text='name'
                        item-value='id'
                        label="Roles"
                        ></v-select>
                    </v-flex> -->
                    <v-flex body-2 pl-2 pt-3>
                        <!-- <v-chip 
                            small
                            :color="filterShowActiveOnly?'green' : ''" 
                            @click="filterShowActiveOnly=!filterShowActiveOnly">
                            <v-avatar v-show="filterShowActiveOnly">
                                <v-icon>check_circle_outline</v-icon>
                            </v-avatar>
                            <v-avatar v-show="!filterShowActiveOnly">
                                <v-icon>radio_button_unchecked</v-icon>
                            </v-avatar>
                            Active Only
                        </v-chip> -->

                    </v-flex>
                        <v-btn color="secondary" @click="loadPromotions">Submit</v-btn>
                    <v-flex>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-card-text>
                <v-layout row>
                    <v-flex xs12>
                        <v-data-table
                            v-bind:headers="headers"
                            :items="promotionItems"
                            hide-actions
                            class="elevation-1"
                            >
                            <template slot="items" slot-scope="props">
                            <td>{{ props.item.itemNumber }}</td>
                            <td>{{ props.item.promotionType }}</td>
                            <td>{{ populatePromotionAmt(props.item) }}</td>
                            <td class="text-xs-left" :class="props.item.active?'green--text':'red--text'">{{ props.item.active }}</td>
                            <td class="text-xs-left">{{ props.item.uom }}</td>
                            <td class="text-xs-left">{{ props.item.promotionCode }}</td>
                            <td class="text-xs-left">{{ props.item.startDate }} - {{ props.item.endDate }}</td>
                            <td class="text-xs-left">{{ props.item.minQty }} - {{ props.item.maxQty }}</td>
                            <td class="text-xs-left">{{ props.item.quoteCreatedCount }}</td>
                            <td class="text-xs-right">
                                <!-- <v-btn small @click.prevent="onActiveDeActiveUser(props.item.id)">{{ props.item.active ? "Deactivate" : "Activate"}}</v-btn> -->
                                
                                <v-btn small @click="editPromotion(props.item)">Edit</v-btn>
                            </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>

            </v-card-text>
        </v-card>

        <v-dialog v-model="ShowPromotionItemEditPopup" width="400" height="500">
            <ctlPromotionItemEdit 
                :originalPromotionData="promotionForAddOrEdit"
                @onClosePromotionPopup="onClosePromotionEditPopup"
                ></ctlPromotionItemEdit>
        </v-dialog>
    </div>
</template>
<script>
import ctlPromotionItemEdit from '@/components/admin/ctlPromotionItemEdit'
import { mapActions } from 'vuex'

export default {
    components: {
        'ctlPromotionItemEdit': ctlPromotionItemEdit,
    },
    data: () => ({
        ShowPromotionItemEditPopup: false,
        promotionForAddOrEdit: {autoApply: false},
        promotionItems: [],
        filterNumber: null,
        filterShowActiveOnly: true,
        filterRole: 'All',
        headers: [
          {
            text: 'Item#',
            align: 'left',
            sortable: true,
            value: 'itemNumber'
          },
          { text: 'Type', align: 'left', value: 'source', sortable: true, },
          { text: 'Amt.', align: 'left', value: 'source', sortable: true, },
          { text: 'Active', value: 'active' },
          { text: 'Unit', align: 'left', value: 'uom', sortable: true },
          { text: 'Code', align: 'left', sortable: true, value: 'promotionCode' },
          { text: 'Date Range', align: 'left', value: '', sortable: true, },
          { text: 'Qty. Range', align: 'left', sortable: false, },
          { text: '', align: 'left', sortable: false }
        ]
        // searchCriteria: {
        //     statusSelected: ['open', 'finished', 'cancelled']
        // },
        // statusList: ['open', 'finished', 'cancelled']
    }),
    computed: {
        userIsAuthenticated () {
            return this.$store.getters.userIsAuthenticated
        },
        user () {
            return this.$store.getters.user
        },
        error () {
            return this.$store.getters.error
        },
        loading () {
            return this.$store.getters.loading
        },
        
    },
    watch: {
        userIsAuthenticated (value) {
            if (!value) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        ...mapActions('adminItemPromotion', [
            'searchItemPromotionAdvanced',
        ]),

        editPromotion: function (promotion) {
            this.promotionForAddOrEdit = promotion
            this.ShowPromotionItemEditPopup = true
        },
        async loadPromotions () {
            const filter = {
                isActive: this.filterShowActiveOnly,
                number: this.filterNumber,
            }

            const result = await this.searchItemPromotionAdvanced(filter)
            if (typeof result === 'string') {
                alert(result)
            } else {
                this.promotionItems = result
            }
        },
        onCreateNewPromotion() {
            this.promotionForAddOrEdit = {minQty: 1, active: true, 
                promotionType: 'DiscountPct'}     //new record
            this.ShowPromotionItemEditPopup = true
        },
        onClosePromotionEditPopup() {
            this.promotionForAddOrEdit = {}     //reset
            this.ShowPromotionItemEditPopup = false
            this.loadPromotions()
        },
        async onActiveDeActiveUser (id) {
            const result = await this.activeDeactiveUser(id)
            if (result === 'successful') {
                this.loadPromotions()
            } else {
                alert(result)
            }
        },
        formatPromotionAmt(promoData) {
            if (promoData.promotionType == 'DiscountPct') {
                return promoData.promotionAmt + '%'
            }
            if (promoData.promotionType == 'PromotionPrice') {
                return '$' + promoData.promotionAmt
            }
            return promoData.promotionAmt
        },
        populatePromotionAmt(itm) {
            if(itm.promotionType == 'BuyXGetYFree'){
                return `Buy ${itm.buyXGetYFreeBuyQty} Get ${itm.buyXGetYFreeGetQty} Free`
            } else {
                return this.formatPromotionAmt(itm)
            }
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: async function () {

        this.loadPromotions()
    },
    destroyed: function () {
        this.onDismissed()
    }
}
</script>